import { pitchTypeTagMap, pitchSpeedDistributionColorMap, pitchTagColorMap, pitchTypeMap } from "../Map"

/* Utils for Options */
export const updateSpeedChartOptions = (personal, options) => {
  let idx = 1, newOptions = {...options}
  for (const p in personal) {
    let initYscale = {
      position: 'left',
      display: true,
      offset: false,
      suggestedMin: 0,
      suggestedMax: 20,
      ticks: { stepSize: 20, display: false },
      stack: 'scale',
      stackWeight: 1,
      title: { display: false },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: false,
        borderWidth: 0,
        drawOnChartArea: false
      },
    }
    newOptions.scales[`y${idx}`] = initYscale
    newOptions.scales['y0'].labels.push([pitchTypeMap[pitchTypeTagMap[p]], `${personal[p].usage} ${Math.round(personal[p].avg)}`])
    if (idx > 1) {
      newOptions.scales[`r${idx}`] = {
        type: 'category',
        position: 'right',
        display: false,
        offset: false,
        stack: 'right',
        title: { display: false },
        grid: {
          display: false,
        },
      }
    }
    idx++
  }
  
  return newOptions
}

/* Utils for Data */
export const wrapSpeedChartData = (global, personal) => {
  let data = {datasets: []}
  let idx = Object.keys(personal).length
  data.datasets.push({                  
    borderColor: 'rgb(100, 100, 100)',
    borderDash: [5, 2],                  
    data: [{x: 161, y: 0},{x: 161, y: 20}],
    yAxisID: `y${idx}`,
    pointRadius: 0,
    borderWidth:2,                  
  })
  for (const p in personal) {
    let pitches = {
      backgroundColor: pitchSpeedDistributionColorMap[p].background,
      borderColor: pitchSpeedDistributionColorMap[p].line,
      data: [],
      yAxisID: `y${idx}`,
    }
    pitches.data.push({x: Math.floor(personal[p].avg-20), y: 0})
    for (const v in personal[p].velos) {
      if (parseInt(v) <= 0) continue
      pitches.data.push({x: parseInt(v), y: personal[p].velos[v]})
    }
    pitches.data.push({x: Math.ceil(personal[p].avg+20), y: 0})
    let averageLine = {
      borderColor: 'rgb(141, 187, 193)',
      borderDash: [5, 2],
      data: [{ x: global[p], y: 0 }, { x: global[p], y: 20 }],
      yAxisID: `y${idx}`,
      pointRadius: 0,
    }
    data.datasets.push(pitches)
    data.datasets.push(averageLine)
    idx--
  }
  return data
}

const initSpinDirData = [{
  backgroundColor:'#FFFFFF',
  hoverBackgroundColor: '#FFFFFF',
  borderWidth: 0,
  hoverBorderWidth: 0,
  borderColor: '#FFFFFF',
  hoverBorderColor: '#FFFFFF',
  data: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30,],
}]
export const wrapSpinDirectionData = (personal) => {
  let data = [...initSpinDirData]
  let cumulatedRadius = [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30,]
  for (const i in personal) {
    for (let d=0; d<24; d++) cumulatedRadius[d]+=6*personal[i][d]
    data.push({
      backgroundColor:pitchTagColorMap[i],
      hoverBackgroundColor:pitchTagColorMap[i],
      borderColor:'#FFFFFF',
      hoverBorderColor:'#FFFFFF',
      borderWidth:2,
      hoverBorderWidth:2,                    
      data: [...cumulatedRadius],
    })
  }
  const labels = ['12:00',"","",'01:30',"","",'03:00',"","",'04:30',"","",'06:00',"","",'07:30',"","",'09:00',"","",'10:30',"","",]
  return { labels: labels, datasets: data}
}

const packPointData = (data, borderWidth) => {
  let dt = []
  for (const i in data) {
    dt.push({
      pointBackgroundColor: pitchTagColorMap[i],
      borderWidth: borderWidth,
      borderColor: "#000000",
      data: data[i],
      label: i,
    })
  }
  return dt
}
export const wrapPointData = (personal, borderWidth) => {
  return {
    labels: ['FB', 'SL', 'CH', 'CB', 'SP', 'SFF', 'SC', 'CT', 'FT', 'KN', 'UN', 'OT'],
    datasets: packPointData(personal, borderWidth)
  }
}

const packTrendData = (data, target, sameStart) => {
  let dt = []
  let typeset = []
  let keptType = undefined
  let byTags = {}
  let idx = 1
  for (const i of data) {
    /*
    if (keptType === undefined) {
      keptType = i.type
      typeset.push({x:idx, y:i[target]})
    } else {
      if (i.type === keptType) {
        typeset.push({x:idx, y:i[target]})
      } else {
        dt.push({
          borderColor: pitchTagColorMap[keptType],
          pointBackgroundColor: pitchTagColorMap[keptType],
          data: [...typeset],
          label: keptType
        })
        keptType = i.type
        typeset = [{x:idx, y:i[target]}]
      }
    }
    */
    if (!sameStart) {
      if (byTags[i.type] === undefined) byTags[i.type] = []
      byTags[i.type].push({x:idx, y:i[target]})
      idx++
    } else {
      if (byTags[i.type] === undefined) byTags[i.type] = []
      byTags[i.type].push({x:byTags[i.type].length, y:i[target]})
    }
  }
  for (const t in byTags) {
    dt.push({
      borderColor: pitchTagColorMap[t],
      pointBackgroundColor: pitchTagColorMap[t],
      data: [...byTags[t]],
      label: t
    })
  }
  return dt
}
export const wrapTrendData = (personal, target, sameStart=true) => {
  return {
    labels: ['FB', 'SL', 'CH', 'CB', 'SP', 'SFF', 'SC', 'CT', 'FT', 'KN', 'UN', 'OT'],
    datasets: packTrendData(personal, target, sameStart)
  }
}